
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
 
interface Check {
  name: string;
  bad: string;
  good: string;
  color: string;
}
 
interface Part {
  t?: string;
  i?: number;
}
 
interface Mark {
  text: string;
  hit: boolean;
  on?: boolean;
  color?: string;
  bg?: string;
}
 
interface Chip {
  name: string;
  color: string;
  on: boolean;
}
 
const CHECKS: Check[] = [
  { name: 'Punctuation', bad: 'However the', good: 'However, the', color: '#EA580C' },
  { name: 'Grammar', bad: 'shows', good: 'show', color: '#DC2626' },
  { name: 'Word choice', bad: 'affect', good: 'effect', color: '#2563EB' },
  { name: 'Spelling', bad: 'tripomastigotes', good: 'trypomastigotes', color: '#DC2626' },
  { name: 'Sentence structure', bad: 'The samples were analysed by the team', good: 'The team analysed the samples', color: '#7C3AED' },
  { name: 'Style', bad: 'for the calculation of', good: 'to calculate', color: '#7C3AED' }
];
 
const PARTS: Part[] = [
  { i: 0 }, { t: ' results ' }, { i: 1 }, { t: ' a clear ' }, { i: 2 }, { t: ' on metacyclic ' },
  { i: 3 }, { t: '. ' }, { i: 4 }, { t: ' ' }, { i: 5 }, { t: ' parasite density.' }
];

@Component({
  selector: 'app-gcchecks',
  templateUrl: './gcchecks.component.html',
  styleUrls: ['./gcchecks.component.scss']
})
export class GCChecksComponent implements OnInit {

  k = 0;
  manual = false;
  a = 0;
 
  before: Mark[] = [];
  after: Mark[] = [];
  chips: Chip[] = [];
 
  private timer: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}
 
  ngOnInit(): void {
    this.refresh();
  
    if (isPlatformBrowser(this.platformId)) {
      this.timer = setInterval(() => {
        if (this.manual) {
          return;
        }
  
        this.k += 1;
        this.refresh();
      }, 3000);
    }
  }
 
  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
 
  trackByIndex(index: number): number {
    return index;
  }
 
  pick(i: number): void {
    this.manual = true;
    this.a = i;
    this.refresh();
  }
 
  private refresh(): void {
    const a = this.manual ? this.a : this.k % CHECKS.length;
 
    this.before = PARTS.map((x): Mark => {
      if (x.t !== undefined) { return { text: x.t, hit: false }; }
      const c = CHECKS[x.i as number];
      const on = x.i === a;
      return { text: c.bad, hit: true, color: c.color, bg: on ? c.color + '1F' : 'transparent' };
    });
 
    this.after = PARTS.map((x): Mark => {
      if (x.t !== undefined) { return { text: x.t, hit: false }; }
      return { text: CHECKS[x.i as number].good, hit: true, on: x.i === a };
    });
 
    this.chips = CHECKS.map((c, i): Chip => ({ name: c.name, color: c.color, on: i === a }));
  }

}
